import { FunctionComponent } from 'react';
import { Card } from 'react-bootstrap';
import { Icons, SquareIcon } from './SquareIcon';
import ApplicationError from '../framework/ApplicationError';
import { Localization } from '../framework/localization/Localization';

type ApplicationErrorsProps = {
  errors?: ApplicationError[];
};

export const ApplicationErrors: FunctionComponent<ApplicationErrorsProps> = ({ errors }) => {
  if ((errors?.length || 0) < 1) return null;

  return (
    <>
      <div>
        {errors?.map((error) => (
          <Card>
            <Card.Header>
              <SquareIcon size={'24px'} color={'red'} className={'icon-rss-alert-red'}>
                {Icons.Alert}
              </SquareIcon>
              {' ' + Localization.instance.getParametrizedString(error.messageKey, error.params)}
            </Card.Header>

            <Card.Body>
              <ul>{error.details?.map((detail) => <li>{detail}</li>)}</ul>
            </Card.Body>
          </Card>
        ))}
      </div>
    </>
  );
};

export default ApplicationErrors;
